export default defineNuxtRouteMiddleware((to, from) => {
  const flash = useFlash()
  if (flash.cookie?.value?.expired) flash.clear()
})
